import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import z from "zod";
import { ticketIdZodSchema } from "../ticket-id";
import {
    GiftCardTicketEventIdFactory,
    giftCardTicketEventIdZodSchema,
} from "./giftcard-ticket-event-id";

const _giftCardRevokedEventZodSchema = z.object({
    _id: giftCardTicketEventIdZodSchema,
    _type: z.literal("REVOKED"),
    _createdAt: isoAndUnixZodSchema,

    _version: z.number().int().min(1),
    providerId: providerIdZodSchema,
    productId: productIdZodSchema,
    ticketId: ticketIdZodSchema,
});

type GiftCardRevokedEvent = z.infer<typeof _giftCardRevokedEventZodSchema>;
type FactoryParams = Except<
    GiftCardRevokedEvent,
    "_id" | "_createdAt" | "_version" | "_type"
>;
/**
 * @param {FactoryParams} params
 * @return {*}
 */
const giftCardRevokedEventFactory = (params: FactoryParams) => {
    const version = 1;
    const newEvent: GiftCardRevokedEvent = {
        ...params,
        _version: version,
        _createdAt: nowIsoAndUnix(),
        _type: "REVOKED",
        _id: GiftCardTicketEventIdFactory(),
    };
    return newEvent;
};

export { giftCardRevokedEventFactory };
export type { GiftCardRevokedEvent };
